import { createClient } from '@sanity/client';

const client = createClient({
  projectId: 'gwr399jf',
  dataset: 'production',
  apiVersion: '2025-01-01', // una fecha reciente
  useCdn: true,             // ok para lecturas públicas
});

export default client;